import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/estados-de-retenciones';

/**
 * GET Retenciones de Pagos
 * @param {object} params
 * @returns {Promiser<object[]>}
 */
export const getEstadosDeRetenciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Retencion de Pago
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getEstadoDeRetencion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
